<template>
	<div class="">
		<ImageScroller :sideButtons="true">
			<router-link
				:to="supply.link"
				class="relative overflow-hidden rounded-lg snap-start w-[calc((100%-1rem)/2)] sm:w-[calc((100%-2rem)/3)] lg:w-[calc((100%-3rem)/4)] shrink-0"
				v-for="(supply, a) in supplies"
				:key="a"
			>
				<div class="cursor-pointer">
					<img :src="supply.image" :alt="supply.alt" class="object-center object-cover w-full md:h-60 lg:h-80 xl:h-96" />
				</div>
				<div class="mt-4 flex w-full justify-center text-center text-sm lg:text-base font-semibold px-4 rounded py-px tracking-wide text-ihh-midnight-gray">
					{{ supply.name }}
				</div>
				<div class="text-base text-ihh-gray-200 flex text-center w-full justify-center px-4 my-2"></div>
			</router-link>
		</ImageScroller>
	</div>
</template>

<script>
import ImageScroller from './image-scroller.vue'
import NextButtonsGray from './next-buttons-gray.vue'
export default {
	components: { NextButtonsGray, ImageScroller },
	data() {
		return {
			supplies: [
				{
					name: 'Gentle Birth Formula by Mountain Meadow Herbs, 4oz.',
					brand: 'Mountain Meadow Herbs',
					price: 33.5,
					image: 'https://cdn11.bigcommerce.com/s-nuj3c/images/stencil/1280w/products/779/4091/G1034_Gentle_Birth_Formula_4_oz__75179.1711143517.png',
					link: '/products/gentle-birth-formula-by-mountain-meadow-herbs-4oz/',
				},
				{
					name: 'Oasis Elite Birth Pool PACKAGE',
					brand: 'Oasis',
					price: 309.68,
					image: 'https://cdn11.bigcommerce.com/s-nuj3c/images/stencil/1280w/products/3541/4805/Oasis_elite_grand__52562.1711143548.png',
					link: '/products/oasis-elite-birth-pool-package/',
				},
				{
					name: 'The Fresh Test Glucose Test Beverage, 50 gram',
					brand: '',
					price: 24.55,
					image: 'https://cdn11.bigcommerce.com/s-nuj3c/images/stencil/1280w/products/3338/4575/Fresh_Test_50_gram__97644.1711143544.jpg',
					link: '/products/the-fresh-test-glucose-test-beverage-50-gram/',
				},
				{
					name: 'Natal K™ - Oral Vitamin K1 Tincture, 1oz. by Dr. Green Life',
					brand: 'Dr. Green Life',
					price: 38.99,
					image: 'https://cdn11.bigcommerce.com/s-nuj3c/images/stencil/1280w/products/4069/5108/9e67c47a-0970-4a7c-98b1-6b084080f0c7__87120.1717008836.jpg',
					link: '/products/natal-k-oral-vitamin-k1-tincture-1oz-by-dr-green-life/',
				},
				{
					name: 'Arjo Huntleigh Sonicaid FD1 MkIII Fetal Doppler with 2MHz waterproof probe',
					brand: 'Arjo Huntleigh',
					price: 684.0,
					image: 'https://cdn11.bigcommerce.com/s-nuj3c/images/stencil/1280w/products/3716/4794/FD1-3_probe_out_1__70131.1711143552.jpg',
					link: '/products/arjo-huntleigh-sonicaid-fd1-mkiii-fetal-doppler-with-2mhz-waterproof-probe/',
				},
				{
					name: 'The Honey Pot Postpartum Herbal Pads, 12 Count',
					brand: '',
					price: 9.5,
					image: 'https://cdn11.bigcommerce.com/s-nuj3c/images/stencil/1280w/products/3263/5035/Untitled_design-8__68580.1712090037.png',
					link: '/products/the-honey-pot-postpartum-herbal-pads-12-count/',
				},
				{
					name: 'Obstetrical Delivery Instrument Pack by E.M. Adams',
					brand: '',
					price: 16.25,
					image: 'https://cdn11.bigcommerce.com/s-nuj3c/images/stencil/1280w/products/995/1339/thumb_IMG_4305_1024__57375.1711143514.jpg',
					link: '/products/obstetrical-delivery-instrument-pack-by-e-m-adams/',
				},
				{
					name: 'Birth Pool in a Box Personal Pool PACKAGE (MINI Size)',
					brand: '',
					price: 318.23,
					image: 'https://cdn11.bigcommerce.com/s-nuj3c/images/stencil/1280w/products/3537/4809/Bpiab_mini_personal__47862.1711143546.png',
					link: '/products/birth-pool-in-a-box-personal-pool-package-mini-size/',
				},
				{
					name: 'Edan SD3 Fetal Doppler with 3MHz Probe',
					brand: 'Edan',
					price: 0.0,
					image: 'https://cdn11.bigcommerce.com/s-nuj3c/images/stencil/1280w/products/4049/5074/img_11844__75396.1714423401.jpg',
					link: '/products/edan-sd3-fetal-doppler-with-3mhz-probe/',
				},
			],
		}
	},
}
</script>
